export const MESSAGE_PAGE_LIMIT = 20;
export const TOP_LOAD_THRESHOLD = 120;
export const TOP_ZONE_EXIT_THRESHOLD = TOP_LOAD_THRESHOLD + 80;
export const BOTTOM_STICK_THRESHOLD = 120;
export const BOTTOM_LOAD_THRESHOLD = 120;
export const BOTTOM_ZONE_EXIT_THRESHOLD = BOTTOM_LOAD_THRESHOLD + 80;
export const BOTTOM_REARM_THRESHOLD = 4;
export const TOP_AUTOLOAD_COOLDOWN_MS = 200;
export const BOTTOM_AUTOLOAD_COOLDOWN_MS = TOP_AUTOLOAD_COOLDOWN_MS;
export const JUMP_MESSAGE_TOP_GAP = 16;
